import React, { useState, useEffect } from 'react';
import EventEmitter from 'react-native-eventemitter';
import { Animated } from 'react-animated-css';
/** library to redirect  */
import { Switch, Route, useRouteMatch, useParams } from 'react-router-dom';

import { Alert } from 'antd';

import PlanificationView from './planification';
import ConstraintsView from './constraints';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import useLookaheadPermissions from '../../hooks/useLookaheadPermissions';
import { useSelector, useDispatch } from 'react-redux';
import { projectService } from '../../services/project.service';
import './index.css';
import { withTranslation } from 'react-i18next';
import * as projectActions from '../../redux/slices/projectSlice';
import LookaHeadSubmodulesMenu from './LookaheadMenuOption';

import ViewsProvider from '../../Context/Planification/ViewsContext';
import { TimerManagerSingleton } from '../../utils/timerManager';

export const TestIds = {
  LOOKAHEAD_MAIN_VIEW_CONTAINER: 'LOOKAHEAD_MAIN_VIEW_CONTAINER'
};

function LookaheadMainView({ t = () => {}, history = () => {} }) {
  const timerManager = TimerManagerSingleton.getInstance();
  const dispatch = useDispatch();

  const { orgId, projectId, scheduleId } = useParams();
  const baseUrl = `/${orgId}/project/${projectId}/schedule/${scheduleId}/lookahead`;

  const { height } = useWindowDimensions();

  const lookaheadPermissions = useLookaheadPermissions();
  const match = useRouteMatch();
  const [userIsOwner, setUserIsOwner] = useState(true);
  const [project, setProject] = useState(null);
  const [_, setContainerHeader] = useState();
  const projectState = useSelector((state) => state.projectState);
  const [hidePlanification, setHidePlanification] = useState(true);

  const projectSelected = projectState.allProjects.find(
    (el) => el.id === projectState.projectSelected
  );

  useEffect(() => {
    if (hidePlanification) {
      const hidePlanificationCallback = () => {
        setHidePlanification(false);
      };
      timerManager.registerAutoTimeout(
        hidePlanificationCallback,
        500,
        'hidePlanification'
      );
    }
  }, [hidePlanification]);

  useEffect(() => {
    const hidePlanificationCallback = () => {
      setHidePlanification(true);
    };
    EventEmitter.on('HIDE_PLANIFICATION', hidePlanificationCallback);

    return () => {
      EventEmitter.removeListener(
        'HIDE_PLANIFICATION',
        hidePlanificationCallback
      );
    };
  }, []);

  useEffect(() => {
    window.Appcues.page();
    projectService
      .show(projectSelected?.id)
      .then((project) => setProject(project));
  }, []);
  return (
    <span data-testid={TestIds.LOOKAHEAD_MAIN_VIEW_CONTAINER}>
      <Animated
        animationIn="fadeIn"
        animationInDuration={500}
        isVisible={true}
        style={{ height: height - 72, overflow: 'auto' }}>
        <ViewsProvider>
          <LookaHeadSubmodulesMenu
            project={project}
            projectSelected={projectSelected}
            userIsOwner={userIsOwner}
            lookaheadPermissions={lookaheadPermissions}
            history={history}
            t={t}
          />
          {userIsOwner && lookaheadPermissions ? (
            <Switch>
              <Route exact path={`${baseUrl}`}>
                {hidePlanification ? (
                  <div></div>
                ) : (
                  <PlanificationView
                    t={t}
                    history={history}
                    setContainerHeader={setContainerHeader}
                    permission={lookaheadPermissions.plan}
                  />
                )}
              </Route>
              <Route exact path={`${baseUrl}/roadblocks`}>
                <ConstraintsView
                  t={t}
                  history={history}
                  setContainerHeader={setContainerHeader}
                  permission={lookaheadPermissions.constraints}
                />
              </Route>
            </Switch>
          ) : (
            <Alert
              className="alert-wide"
              message={t('no_permissions')}
              type="error"
            />
          )}
        </ViewsProvider>
      </Animated>
    </span>
  );
}

export default withTranslation()(LookaheadMainView);
